module.exports = __webpack_public_path__ + "media/ncsa/ncsa-logo-bb6353f3.png";